import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireDist } from "/home/runner/work/timespan/timespan/dist/index.js";
var distExports = requireDist();
export { distExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(distExports);